export default "__VITE_ASSET__orkWbf7L__"